import React from 'react'
import PropTypes from 'prop-types'
import { RatingNa } from 'components/common/rating/RatingNa'

const ReviewCountPropTypes = {
  reviewCount: PropTypes.number,
  url: PropTypes.string,
  children: PropTypes.node,
  noReviewContent: PropTypes.node
}

type ReviewCountProps = PropTypes.InferProps<typeof ReviewCountPropTypes> & {
  children?: React.ReactNode
  noReviewContent?: React.ReactNode
}

const plainReviewCount = (reviewCount: number): React.ReactElement => (
  <span className='review-count'>
    &nbsp;
    ({reviewCount.toString()})
  </span>
)

const linkedReviewCount = (reviewCount: number, url: string): React.ReactElement => (
  <span className='review-count'>
    &nbsp;
    (<a href={url} rel='noreferrer'>{reviewCount.toString()}</a>)
  </span>
)

export const ReviewCount = ({ reviewCount, url, children, noReviewContent }: ReviewCountProps): React.ReactElement => {
  noReviewContent = noReviewContent ?? <RatingNa />
  if (reviewCount == null) {
    return <>{noReviewContent}</>
  }

  return (
    <>
      {children}
      {(url != null) ? linkedReviewCount(reviewCount, url) : plainReviewCount(reviewCount)}
    </>
  )
}
